import { render, staticRenderFns } from "./ListaApps.vue?vue&type=template&id=90a45f04&"
import script from "./ListaApps.vue?vue&type=script&lang=js&"
export * from "./ListaApps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports